import { normalizeReferenceId } from './referenceOptionUtils';

/**
 * Normalize a create/manage API response into a Select-friendly option.
 * Keeps original fields for filtering (department_id, type, code, etc.).
 *
 * @param {string} entity
 * @param {object} response - API data object (already unwrapped from envelope)
 * @returns {{ id: number|null, name: string, meta: object, raw: object }}
 */
export function normalizeReferenceOption(entity, response) {
  const item = response?.data && typeof response.data === 'object' && !Array.isArray(response.data)
    ? response.data
    : response;

  if (!item || typeof item !== 'object') {
    return { id: null, name: '', meta: {}, raw: item };
  }

  const id = normalizeReferenceId(item.id);
  const name = item.name != null ? String(item.name) : '';

  const option = {
    ...item,
    id,
    name,
    meta: {
      departmentId: normalizeReferenceId(item.department_id),
      type: item.type ?? null,
      code: item.code ?? null,
      entity,
    },
    raw: item,
  };

  return option;
}
